'use es6';

import PropTypes from 'prop-types';
import SVGWrapper from './SVGWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGImage = props => {
  return /*#__PURE__*/_jsx(SVGWrapper, Object.assign({}, props));
};
SVGImage.propTypes = {
  image: PropTypes.string
};
export default SVGImage;